import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("AdministrationOfferDocGenerationStore");

const urls = {
  offerDocGenerationWithId: (id) =>
    `/administration/offer-doc-generation/${id}`,
  offerDocGenerationWithOfferId: (offerId) =>
    `/administration/offer-doc-generation/${offerId}`,
  offerDocGenerationsWithApplicationId: (applicationId) =>
    `/administration/merchant/offer-doc-generations/${applicationId}`,
  offerDocGenerationWithMerchantConfigId: (merchantConfigId) =>
    `/administration/offer-doc-generation/merchant/${merchantConfigId}`,
  offerDocGenerationsWithMerchantConfigId: (merchantConfigId) =>
    `/administration/offer-doc-generations/merchant/${merchantConfigId}`,
};

/**
 * Administration OfferDocGeneration store
 */

const initState = () => {
  return {
    offerDocGenerationList: [],
    offerDocGenerationData: {},
    offerDocGenerationMerchantList: [],
  };
};

const actions = {
  fetchList: async ({ commit }, applicationId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(
        urls.offerDocGenerationsWithApplicationId(applicationId)
      );
      commit("saveList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchListForMerchant: async ({ commit }, merchantConfigId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(
        urls.offerDocGenerationsWithMerchantConfigId(merchantConfigId)
      );
      commit("saveListForMerchant", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchOne: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.offerDocGenerationWithId(id));
      commit("saveOne", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  create: async ({}, { offerId, request }) => {
    try {
      const axios = await network.connection();
      const { data: offerDocGeneration } = await axios.post(
        urls.offerDocGenerationWithOfferId(offerId),
        request
      );

      return Promise.resolve(offerDocGeneration);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  createForMerchant: async ({}, { merchantConfigId, request }) => {
    try {
      const axios = await network.connection();
      const { data: offerDocGeneration } = await axios.post(
        urls.offerDocGenerationWithMerchantConfigId(merchantConfigId),
        request
      );

      return Promise.resolve(offerDocGeneration);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  update: async ({}, request) => {
    try {
      const axios = await network.connection();
      const { data: offerDocGeneration } = await axios.put(
        urls.offerDocGenerationWithId(request.id),
        request
      );

      return Promise.resolve(offerDocGeneration);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  delete: async ({}, id) => {
    try {
      const axios = await network.connection();
      await axios.delete(urls.offerDocGenerationWithId(id));

      return Promise.resolve(id);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveList: (state, listData) => {
    state.offerDocGenerationList = listData;
  },
  saveOne: (state, data) => {
    state.offerDocGenerationData[data.id] = data;
  },
  saveListForMerchant: (state, listData) => {
    state.offerDocGenerationMerchantList = listData;
  },
};

const getters = {
  list: (state) => {
    return state.offerDocGenerationList;
  },
  get: (state) => (id) => {
    return state.offerDocGenerationData[id];
  },
  listForMerchant: (state) => {
    return state.offerDocGenerationMerchantList;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
